module.exports = __webpack_public_path__ + "img/academy-course-illustration1.e026da4c.png";